@if (valueAddedTaxEntity$ | async) {
  <form [formGroup]="btwOverzichtFg">
    @if (isJaarAangifte) {
      <div formGroupName="berekening">
        <div class="row">
          <div class="col col-1 pt-3">
            <p>Jaaraangifte</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwJaar" id="verschuldigdeBtwJaar"
                                              label="Verschuldigd"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwJaar" id="voorbelastingBtwJaar"
                                              label="Voorbelasting"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtJaar" id="afdrachtJaar"
                                              label="Af te dragen"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </div>
    } @else if (isKwartaalAangifte) {
      <div formGroupName="berekening">
        <div class="row">
          <div class="col col-1 pt-3">
            <p>Eerste kwartaal</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwKwartaal1"
                                              id="verschuldigdeBtwKwartaal1"
                                              label="Verschuldigd"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwKwartaal1"
                                              id="voorbelastingBtwKwartaal1"
                                              label="Voorbelasting"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtKwartaal1" id="afdrachtKwartaal1"
                                              label="Af te dragen"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Tweede kwartaal</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwKwartaal2"
                                              id="verschuldigdeBtwKwartaal2"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwKwartaal2"
                                              id="voorbelastingBtwKwartaal2"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtKwartaal2"
                                              id="afdrachtKwartaal2"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Derde kwartaal</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwKwartaal3"
                                              id="verschuldigdeBtwKwartaal3"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwKwartaal3"
                                              id="voorbelastingBtwKwartaal3"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtKwartaal3"
                                              id="afdrachtKwartaal3"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Vierde kwartaal</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwKwartaal4"
                                              id="verschuldigdeBtwKwartaal4"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwKwartaal4"
                                              id="voorbelastingBtwKwartaal4"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtKwartaal4"
                                              id="afdrachtKwartaal4"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </div>
    } @else {
      <div formGroupName="berekening">
        <div class="row">
          <div class="col col-1 pt-3">
            <p>Januari</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand1"
                                              id="verschuldigdeBtwMaand1"
                                              label="Verschuldigd"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand1"
                                              id="voorbelastingBtwMaand1"
                                              label="Voorbelasting"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand1" id="afdrachtMaand1"
                                              label="Af te dragen"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Februari</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand2"
                                              id="verschuldigdeBtwMaand2"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand2"
                                              id="voorbelastingBtwMaand2"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand2"
                                              id="afdrachtMaand2"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Maart</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand3"
                                              id="verschuldigdeBtwMaand3"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand3"
                                              id="voorbelastingBtwMaand3"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand3"
                                              id="afdrachtMaand3"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>April</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand4"
                                              id="verschuldigdeBtwMaand4"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand4"
                                              id="voorbelastingBtwMaand4"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand4"
                                              id="afdrachtMaand4"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Mei</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand5"
                                              id="verschuldigdeBtwMaand5"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand5"
                                              id="voorbelastingBtwMaand5"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand5"
                                              id="afdrachtMaand5"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Juni</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand6"
                                              id="verschuldigdeBtwMaand6"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand6"
                                              id="voorbelastingBtwMaand6"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand6"
                                              id="afdrachtMaand6"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Juli</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand7"
                                              id="verschuldigdeBtwMaand7"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand7"
                                              id="voorbelastingBtwMaand7"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand7"
                                              id="afdrachtMaand7"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Augustus</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand8"
                                              id="verschuldigdeBtwMaand8"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand8"
                                              id="voorbelastingBtwMaand8"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand8"
                                              id="afdrachtMaand8"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>September</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand9"
                                              id="verschuldigdeBtwMaand9"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand9"
                                              id="voorbelastingBtwMaand9"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand9"
                                              id="afdrachtMaand9"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>Oktober</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand10"
                                              id="verschuldigdeBtwMaand10"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand10"
                                              id="voorbelastingBtwMaand10"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand10"
                                              id="afdrachtMaand10"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>November</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand11"
                                              id="verschuldigdeBtwMaand11"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand11"
                                              id="voorbelastingBtwMaand11"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand11"
                                              id="afdrachtMaand11"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
        <div class="row">
          <div class="col col-1">
            <p>December</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeBtwMaand12"
                                              id="verschuldigdeBtwMaand12"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="voorbelastingBtwMaand12"
                                              id="voorbelastingBtwMaand12"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-4">
            <snelstart-ui-number-form-control [align]="right"
                                              [disabledControl]="true"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="afdrachtMaand12"
                                              id="afdrachtMaand12"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
        </div>
      </div>
    }
    <div formGroupName="berekening">
      <div class="row">
        <div class="col col-1">
          <p>Totaal</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [align]="right"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="totaalVerschuldigd"
                                            id="totaalVerschuldigd"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [align]="right"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="totaalVoorbelasting"
                                            id="totaalVoorbelasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control [align]="right"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="totaalAangiften"
                                            id="totaalAangiften"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
      <div class="row">
        <div class="col col-1">
          <p>Aangegeven op suppleties</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control [align]="right"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="totaalSuppleties"
                                            id="totaalSuppleties"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-1">
        <p>Afgedragen via bank</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [align]="right"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="cumulatieveAfdrachten"
                                          id="cumulatieveAfdrachten"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
    <div formGroupName="berekening">
      <div class="row">
        <div class="col col-1">
          <p>Saldo</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control [align]="right"
                                            [disabledControl]="true"
                                            [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="verschuldigdeOmzetbelasting"
                                            id="verschuldigdeOmzetbelasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </div>
  </form>
}
